export default __webpack_public_path__ + "static/media/patent01.dabc4810.png";